
      import ArrowLeft from './arrow-left.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowLeftPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowLeft', ArrowLeft)
        },
      }
      export { ArrowLeft }
      